import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LangService } from '../../service/lang.service';
import { translations } from '../../service/trans';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {
  email = 'info@lcc-libya.com';
  // @Input() lang!: string;
  // @Input() t: any;
  lang = 'en';
  t: any;

  constructor(private langService: LangService) {}

  ngOnInit() {
    this.langService.lang$.subscribe((lang) => {
      this.lang = lang;
      this.t = translations[lang];
    });
  }
}
